module.exports = __webpack_public_path__ + "static/img/blop.baa5be1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blop.png
// module id = F+Y0
// module chunks = 0